import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ButtonHTMLAttributes } from 'react';
import type { ButtonContentAlignType, ButtonProps } from '../../components/button/types';
import { GLOBAL_ICONS } from '../../util/vars';
import { Button } from '../../components';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  children?: string | null,
  /**
  * Sets button content align.
  */
  align?: ButtonContentAlignType;
  /**
  * Styles button as a link.
  */
  asLink?: boolean;
}

const NewButton = ({
  children,
  color,
  ...other
}: Props): JSX.Element => {

  const { translate } = useI18n();

  return (
    <Button isOutline color={color ?? 'positive'} icon={GLOBAL_ICONS.add} {...other}>
      {children ?? translate('components.BUTTONS.NEW')}
    </Button>
  );
};

NewButton.displayName = 'NewButton';

export default NewButton;
